import Dialog from './src/dialog';

Dialog.install = function(Vue) {
  Vue.component(Dialog.name, Dialog);
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/dialog/index.js